module.exports = __webpack_public_path__ + "static/img/jdwx1.902919c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/jdwx1.png
// module id = ZiUM
// module chunks = 59